var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_919_623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.70131 9.58385C2.213 8.51063 1.98442 7.3352 2.0052 6.15977C2.01559 5.71004 2.06754 5.23987 2.28572 4.84124C2.47274 4.4835 2.77404 4.20753 3.10651 3.97245C4.19742 3.22631 5.67275 3.06277 6.89873 3.55338C8.12471 4.044 9.07016 5.1581 9.3299 6.43574C8.47795 5.76115 8.44678 4.40174 9.04938 3.5125C9.65198 2.62326 10.7637 2.15309 11.8442 2.03043C12.3533 1.96911 12.8728 1.97933 13.3507 2.16331C14.5559 2.63348 15.0546 4.07466 15.1169 5.3523C15.2208 7.44763 14.5767 9.53274 13.6 11.4032C12.9143 12.7217 12.0832 13.9994 11.1585 15.1748C10.1922 16.4116 9.40263 15.829 8.23899 15.1033C6.00522 13.7132 3.79222 12.0267 2.69092 9.58385H2.70131Z",
    stroke: "#DE296E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_919_623"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.2104,
    height: 15.9347,
    fill: "white",
    transform: "translate(0.966797 0.967407)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeart);
export default __webpack_public_path__ + "static/media/icon_heart.65110b847eca742e317dd377f174573b.svg";
export { ForwardRef as ReactComponent };